import { Box, Divider, Typography } from "@mui/material";

const formatAmount = (value) => {
  const num = Number(value) || 0;
  return num.toFixed(2);
};

const BillRow = ({
  label,
  value,
  bold = false,
  color,
  prefix = "₹",
  format = formatAmount,
}) => (
  <Box display="flex" justifyContent="space-between" py={0.5}>
    <Typography
      fontSize="13px"
      fontWeight={bold ? 600 : 400}
      color={color || "text.secondary"}
    >
      {label}
    </Typography>
    <Typography
      fontSize="13px"
      fontWeight={bold ? 600 : 400}
      color={color || "text.primary"}
    >
      {prefix}{format(value)}
    </Typography>
  </Box>
);

export const BillSection = ({
  itemTotal = 0.0,
  deliveryFee = 0.0,
  discount = 0.0,
  tax = 0.0,
  TransactionFee = 0.0,
  taxPercentage = null,
  grandTotal = 0.0,
}) => {
  // Format tax label with percentage if available
  const taxLabel = taxPercentage !== null && taxPercentage > 0
    ? `Taxes & Charges`
    : "Taxes & Charges";

  return (
    <Box
      border="1px solid #E0E0E0"
      borderRadius={2}
      sx={{padding:'10px'}}
      bgcolor="#fff"
    >
      <Typography fontWeight={600} fontSize="14px" mb={1}>
        Bill Details
      </Typography>

      <BillRow label="Item Total" value={itemTotal} />
      <BillRow label="Delivery Fee" value={deliveryFee} />

      {discount > 0 && (
        <BillRow
          label="Discount"
          value={-discount}
          color="success.main"
        />
      )}

      <BillRow label={taxLabel} value={tax} />
      <BillRow
        label="Transaction Fee (2.9%)"
        value={TransactionFee}
      />

      <Divider sx={{ my: 1 }} />

      <BillRow
        label="Grand Total"
        value={grandTotal}
        format={(v) => Number(v).toFixed(2)} 
        bold
      />
    </Box>
  );
};

